import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { GoogleLogin, GoogleMobileLogin } from '../../assets';
import SocialLoginBtn from './SocialLoginBtn';
import { SocialLoginButtonsProps, SocialLoginPlatformEnum } from './type';

export default function GoogleLoginBtn({ afterSocialLoginSuccess, dataSocial }: SocialLoginButtonsProps) {
  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        const res = await axios.get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${tokenResponse.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
              Accept: 'application/json',
            },
          }
        );
        if (res.status === 200) {
          afterSocialLoginSuccess({
            type: SocialLoginPlatformEnum.GOOGLE,
            socialId: res.data.id,
            email: res.data.email,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    onError: () => {
      console.log('login fail');
    },
  });
  return (
    <div data-social={dataSocial}>
      <SocialLoginBtn 
        onClick={login}
        backgroundColor='bg-white'
        fontColor='text-[#121212]'
        additionalStyle='border md:border-gray-400 border-gray-300'
        icon={
          <>
            <GoogleLogin className='md:block hidden' width={24} height={24} />
            <GoogleMobileLogin className='block md:hidden' />
          </>
        }
        text="google"
      />
    </div>
  );
}
